import { render } from "./i1.vue?vue&type=template&id=9618ec26&scoped=true"
const script = {}

import "./i1.vue?vue&type=style&index=0&id=9618ec26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9618ec26"]])

export default __exports__